import { ButtonVariants } from '@src/components/Button';
import type { EntityAdminRecord } from '@src/components/EntityAdmin/types';
import { ToggleGroup } from '@src/components/Form/ToggleGroup';
import { get } from 'lodash-es';
import type { ToggleDrawerOption } from '../types';

export function ToggleGroupContent<TDrawerRecord extends EntityAdminRecord>({
  drawerOption,
  form,
  originalEntity,
  isEditing,
  onFormUpdate,
}: {
  drawerOption: ToggleDrawerOption<TDrawerRecord>;
  form: TDrawerRecord;
  originalEntity: TDrawerRecord | undefined;
  isEditing: boolean;
  onFormUpdate: (field: keyof TDrawerRecord, value: string | boolean, suppressTouch?: boolean) => void;
}) {
  return (
    <ToggleGroup
      value={get(form, drawerOption.field) as string | undefined}
      defaultValue={drawerOption.defaultValue}
      onChange={value => {
        onFormUpdate(drawerOption.field, value);
        drawerOption.onChange?.(value, onFormUpdate, form);
      }}
      disabled={(drawerOption.disabledWhenEditing && isEditing) || drawerOption.getIsDisabled?.(form, originalEntity)}
      options={drawerOption.getToggleOptions(form, isEditing)}
      data-testid={`entity-admin-drawer-${String(drawerOption.field)}`}
      boxProps={{ w: '100%' }}
      defaultSelectedVariant={ButtonVariants.Priority}
    />
  );
}
